import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ProductImageModule} from '../product-image/product-image.module';
import {ButtonModule} from '../button/button.module';
import {ProductCardGroupComponent} from './product-card-group.component';

@NgModule({
  declarations: [ProductCardGroupComponent],
  exports: [ProductCardGroupComponent],
  imports: [CommonModule, RouterModule, ProductImageModule, ButtonModule],
})
export class ProductCardGroupModule {}
